<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedication</a>
</li>
<li id="level1-front5">
<a href="#/front03">Epigraph</a>
</li>
<li id="c001">
<a href="#/c001">PRELUDE</a>
</li>
<li id="c01">
<a href="#/c01">The Name</a>
</li>
<li id="c02">
<a href="#/c02">The Files</a>
</li>
<li id="c002">
<a href="#/c002">WAR</a>
</li>
<li id="c03">
<a href="#/c03">A Mighty Endeavor</a>
</li>
<li id="c04">
<span href="#/c04" title="Link target outside of Sample">Master of Ceremonies</span>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">Handkerchief</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">Intercedite Pro Nobis</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">A Jew’s Fantasy</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">Cleopatra’s Needle</span>
</li>
<li id="c003">
<span href="#/c003" title="Link target outside of Sample">POSTWAR</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">Road Out</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">Reds</span>
</li>
<li id="c11">
<span href="#/c11" title="Link target outside of Sample">Obbedienza</span>
</li>
<li id="c12">
<span href="#/c12" title="Link target outside of Sample">Nakam Means Revenge</span>
</li>
<li id="c13">
<span href="#/c13" title="Link target outside of Sample">Ratline</span>
</li>
<li id="c14">
<span href="#/c14" title="Link target outside of Sample">Vieni! Come!</span>
</li>
<li id="level1-back23">
<span href="#/back01" title="Link target outside of Sample">Author’s Note</span>
</li>
<li id="level1-back24">
<span href="#/back02" title="Link target outside of Sample">About the Author</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2cac9e60